import { render, staticRenderFns } from "./TemplateGrid.vue?vue&type=template&id=858058b0&scoped=true&"
import script from "./TemplateGrid.vue?vue&type=script&lang=js&"
export * from "./TemplateGrid.vue?vue&type=script&lang=js&"
import style0 from "./TemplateGrid.vue?vue&type=style&index=0&id=858058b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858058b0",
  null
  
)

export default component.exports